import request from '@/utils/request'



export function registerApi(data) {
	return request({
		url: '/api/common/v1/user/register',
		method: 'post',
		data,
		headers: {
			isToken: false
		}
	})
}

export function registerUserApi(data) {
	return request({
		url: '/register/user',
		method: 'post',
		data
	})
}

export function registerUkeyApi(data) {
	return request({
		url: '/register/key',
		method: 'post',
		data
	})
}

